<template>
  <div class="is-flex is-justify-content-center">
    <dashboard-chart-line
      :chartData="chartData"
      :chartOptions="chartOptions"
      :chartId="'widgetPPEs'"
    />
  </div>
</template>

<script>
import DashboardChartLine from "@/components/DashboardChartLine.vue";
import MixinDashboardWidget from "@/mixins/MixinDashboardWidget.js";

export default {
  name: "DashboardWidgetPPEsAlerts",
  components: {
    DashboardChartLine,
  },
  props: {
    dates: {
      type: Array,
      require: true,
    },
    ppesAlerts: {
      type: Array,
      require: true,
    },
  },
  mixins: [MixinDashboardWidget],
  data() {
    return {
      chartData: {
        labels: [],
        datasets: [
          {
            label: "PPEs Alerts",
            pointBackgroundColor: "#3426D7",
            borderColor: "rgba(255, 255, 255, 0.5)",
            borderWidth: 1,
            data: [],
            tension: 0.2,
            showGrid: false,
          },
        ],
      },
    };
  },
  mounted() {
    this.setPPEsData();
    this.setChartTitle(this.ppesAlerts);
    this.chartOptions.plugins.title.text[1] = "PPEs";
  },
  methods: {
    async setPPEsData() {
      this.chartData.labels = this.dates;
      this.chartData.datasets[0].data = this.ppesAlerts;
    },
  },
};
</script>
